import React, { Component } from 'react';
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import { TimeFormats } from "../../../../../common/constants";
import moment from 'moment';

const TITLE = "CALL LOGS";

export default class ShowCallLogs extends Component {
    render() {
        let booking = this.props && this.props.booking ? this.props.booking : null;
        let call_logs = booking && booking.call_logs && booking.call_logs.length > 0 ? booking.call_logs : [];
        let is_call_logs_exists = call_logs.length > 0;
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                {!is_call_logs_exists &&
                    <div style={style.label}>
                        There is no call logs found for this booking.
                    </div>
                }
                {is_call_logs_exists && <div className="table-call-logs">
                    <table style={style.table}>
                        <tr>
                            {/* <tr style={{ marginTop: 10 }}> */}
                            <th style={style.table_head}>Client</th>
                            <th style={style.table_head}>Id</th>
                            <th style={style.table_head}>Event</th>
                            <th style={style.table_head}>Date</th>
                        </tr>
                        {call_logs.map((val, key) => {
                            return (
                                <tr key={key}>
                                    <td style={style.table_data}>{val.client_type}</td>
                                    <td style={style.table_data}>{val.id}</td>
                                    <td style={style.table_data}>{val.event_type}</td>
                                    <td style={style.table_data}>{this.getDateTime(val.timestamp)}</td>
                                </tr>
                            )
                        })}
                    </table>
                </div>
                }
            </ModalOverlay>
        )
    }

    getDateTime = (timestamp) => {
        return moment(timestamp, TimeFormats.bookingTimeFormat).format("MMM DD, YYYY, hh:mm a");
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3,
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 60,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    label: {
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
        marginLeft: 10,
        marginRight: 10
    },
    table: {
        border: "2px solid rgb(68, 68, 69)",
    },
    table_head: {
        border: "1px solid rgb(68, 68, 69)",
    },
    table_data: {
        border: "1px solid rgb(68, 68, 69)",
        textAlign: "left",
        padding: 10,
    }
}